export default "__VITE_ASSET__BM3_0m9w__"